// Translation: Utility > Loading error (German)
export default Object.freeze({
	description: '',
	title: ''
})
